const DateSection = (props) => {
  const parseDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString.replace(" ", "T"));
      const timeString = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      return "Selected Time: " + timeString;
    }
    return " ";
  };

  return (
    <div
      style={{
        display: "flex",
        ...(props.mode === "add" && { flexDirection: "column", alignItems: "center", gap: "16px" }),
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: props.mode === "remove" ? "left" : "center",
          position: "relative",
        }}
      >
        <DateField
          label={props.mode === "add" ? "Employee Start Date" : "Effective Date"}
          onChange={(e) => props.onCalendarClick(e.target.value)}
          value={props.user && props.user.effectiveDate ? props.dateTimeOnCalendarInput.dateToShow : ""}
        />
        {parseDateString(props.user ? props.user.effectiveDate : "")}
      </div>
    </div>
  );
};

const DateField = ({ label, onChange, value }) => (
  <div style={{ display: "flex", flexDirection: "column", width: "250px" }}>
    {label}
    <input
      type="date"
      className="date-input form-control"
      onChange={onChange}
      value={value}
      style={{ width: "100%", borderRadius: "5px", paddingLeft: "10px" }}
    />
  </div>
);

export default DateSection;
